import { accountingJournalTypeOptions } from './../../../../../../../../types/src/mado/enum/journal-type.enum';
import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { Validators } from '@angular/forms';

import { fb } from '../../../../../modules/shared/shared.global-service';
import { isInvalid } from '../../../../../modules/shared/helpers/validate';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { TextInputComponent } from '../../../../kit/input/text-input/text-input.component';
import { AccountingJournalGridObject, AccountingJournalObject } from '@libs/types/src/mado/object-type/journal.object';
import { journalMutationFrag } from './organization-settings-journal-dialog.query';
import { OrganizationSettingJournalDialogStore } from './organization-settings-journal-dialog.store';
import { SelectInputComponent } from '../../../../kit/input/select-input/select-input.component';
import { AccountingJournalUpdateInput } from '@libs/types/src/mado/input-type/journal.update-input';
import { AccountingJournalCreateInput } from '@libs/types/src/mado/input-type/journal.create-input';
import { SwitchInputComponent } from "../../../../kit/input/switch-input/switch-input.component";

@Component({
    selector: 'app-organization-settings-journal-dialog',
    templateUrl: './organization-settings-journal-dialog.component.html',
    providers: [OrganizationSettingJournalDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TextInputComponent,
        SelectInputComponent,
        SwitchInputComponent,
    ],
})
export class OrganizationSettingsJournalDialogComponent extends BaseDialogComponent {
    protected readonly store = inject(OrganizationSettingJournalDialogStore);

    protected readonly translatePrefix = 'madoJournal.';

    protected readonly data = this.dialogConfig.data.journal || null;
    protected readonly organizationId = this.dialogConfig.data.organizationId || null;

    journalOptions = signal<AccountingJournalGridObject[]>([])

    protected form = fb.group({
        name: fb.control<string | null>(null, [Validators.required]),
        code: fb.control<string | null>(null, [Validators.required]),
        type: fb.control<string | null>(null, [Validators.required]),
        accountId: fb.control<number | null>(null),
        currencyId: fb.control<number | null>(null),
        isDefault: fb.control<boolean | null>(null),
    })

    constructor() {
        super();

        if (this.data) {
            this.patchForm(this.data);
        }
    }

    override async save() {
        if (isInvalid(this.form)) return;
        
        const _data = {
            name: this.form.value.name!,
            code: this.form.value.code!,
            type: this.form.value.type!,
            accountId: this.form.value.accountId!,
            currencyId: this.form.value.currencyId!,
            isDefault: this.form.value.isDefault!,
        }

        if (this.data) {
            // UPDATE
            const data = {
                ..._data,
                id: this.data.id,
            } as AccountingJournalUpdateInput

            await this.store.api.updateAccountingJournal(data, journalMutationFrag);
            

        } else {
            // CREATE
            if (!this.organizationId) return;
            const data = {
                ..._data,
                organizationId: Number(this.organizationId),
            } as AccountingJournalCreateInput

            await this.store.api.createAccountingJournal(data, journalMutationFrag);
        }

        this.dialogRef.close(true);
    }

    private patchForm(item: AccountingJournalObject) {        
        this.form.patchValue({
            name: item?.name,
            code: item?.code,
            type: item?.type,
            accountId: item?.accountId,
            currencyId: item?.currencyId,
            isDefault: item?.isDefault,
        })
    }

    protected readonly accountingJournalTypeOptions = accountingJournalTypeOptions;
}
